// Rewards program — ОПРЕДЕЛЕНИЕ программы лояльности (тиры, квесты). Это
// продуктовый контент, не пользовательские факты. Пользовательские значения
// (points, GRAM earned, прогресс квестов, рефералы) приходят из userland-API
// после его мержа — до тех пор страница показывает честные нули (гость на
// стартовом тире).

export type TierStatus = 'locked' | 'next' | 'current' | 'achieved'

export interface Tier {
  name: string
  /** Reward multiplier. */
  multiplier: string
  /** Referral cashback. */
  cashback: string
  status: TierStatus
  /** Metal accent (pixel badge + tier-chip/row tint). Tier-specific — every
      OTHER accent on the screen stays brand-blue (dosed accent rule). */
  metal: string
  /** Pixel-badge level 0=Bronze … 4=Diamond (drives PixelRank grandeur). */
  level: number
}

// Highest tier first (Diamond → Bronze). Гость стартует на Bronze.
export const TIERS: Tier[] = [
  {
    name: 'Diamond',
    multiplier: '4×',
    cashback: '40%',
    status: 'locked',
    metal: '#8fdcef',
    level: 4,
  },
  {
    name: 'Platinum',
    multiplier: '3.5×',
    cashback: '35%',
    status: 'locked',
    metal: '#d6dde6',
    level: 3,
  },
  { name: 'Gold', multiplier: '3×', cashback: '30%', status: 'locked', metal: '#e8b84b', level: 2 },
  { name: 'Silver', multiplier: '2×', cashback: '20%', status: 'next', metal: '#aeb6bf', level: 1 },
  {
    name: 'Bronze',
    multiplier: '1×',
    cashback: '10%',
    status: 'current',
    metal: '#c08a55',
    level: 0,
  },
]

export const CURRENT_TIER = TIERS.find((t) => t.status === 'current') ?? TIERS[TIERS.length - 1]
export const NEXT_TIER = TIERS.find((t) => t.status === 'next')

export interface Quest {
  label: string
  /** Points reward (the "pts" suffix is rendered by the component). */
  reward: string
}

export interface QuestGroup {
  /** Group eyebrow (Daily / Seasonal). */
  label: string
  /** Cadence copy (без фейковых таймеров — реальные придут с бэкендом). */
  cadence: string
  items: Quest[]
}

export const QUEST_GROUPS: QuestGroup[] = [
  {
    label: 'Daily',
    cadence: 'resets daily',
    items: [
      { label: 'Make 5 trades', reward: '+150' },
      { label: 'Trade 5 GRAM volume', reward: '+200' },
      { label: 'Hold a position for 24h', reward: '+225' },
    ],
  },
  {
    label: 'Seasonal',
    cadence: 'season 1',
    items: [
      { label: 'Reach 1,000 GRAM volume', reward: '+1,000' },
      { label: 'Refer 3 friends', reward: '+800' },
      { label: 'Trade 10 different tokens', reward: '+500' },
    ],
  },
]
